// AUTO-GENERATED by scripts/gen_features.py — DO NOT EDIT.
// Source of truth: config/features/registry.json
// Regenerate with: python scripts/gen_features.py

export const FEATURE_KEYS = [
  'sms.timesheet_reminder',
  'sidebar.overview',
  'sidebar.matching',
  'sidebar.orders',
  'sidebar.clients',
  'sidebar.supervisor',
  'sidebar.employees',
  'sidebar.applicants',
  'sidebar.communications',
  'sidebar.timesheets',
  'sidebar.tools',
  'sidebar.skills',
  'sidebar.template_docs',
  'sidebar.global_search',
  'sidebar.dashboard_employees',
  'sidebar.dashboard_supervisors',
  'sidebar.dashboard_employee_calls',
  'sidebar.dashboard_clients',
  'sidebar.dashboard_map',
  'sidebar.absences',
  'sidebar.alerts',
  'sidebar.hour_alerts',
  'sidebar.formations',
  'employee.ccq_union',
  'employee.ramq',
  'employee.qualifications_ccq',
  'employee.qualifications_trades',
  'i18n.language_switch',
] as const

/** Union of every valid feature-flag key. A typo'd key is a compile error. */
export type FeatureKey = (typeof FEATURE_KEYS)[number]

/** Named constants — use these instead of raw strings at call sites. */
export const FeatureKeys = {
  SMS_TIMESHEET_REMINDER: 'sms.timesheet_reminder',
  SIDEBAR_OVERVIEW: 'sidebar.overview',
  SIDEBAR_MATCHING: 'sidebar.matching',
  SIDEBAR_ORDERS: 'sidebar.orders',
  SIDEBAR_CLIENTS: 'sidebar.clients',
  SIDEBAR_SUPERVISOR: 'sidebar.supervisor',
  SIDEBAR_EMPLOYEES: 'sidebar.employees',
  SIDEBAR_APPLICANTS: 'sidebar.applicants',
  SIDEBAR_COMMUNICATIONS: 'sidebar.communications',
  SIDEBAR_TIMESHEETS: 'sidebar.timesheets',
  SIDEBAR_TOOLS: 'sidebar.tools',
  SIDEBAR_SKILLS: 'sidebar.skills',
  SIDEBAR_TEMPLATE_DOCS: 'sidebar.template_docs',
  SIDEBAR_GLOBAL_SEARCH: 'sidebar.global_search',
  SIDEBAR_DASHBOARD_EMPLOYEES: 'sidebar.dashboard_employees',
  SIDEBAR_DASHBOARD_SUPERVISORS: 'sidebar.dashboard_supervisors',
  SIDEBAR_DASHBOARD_EMPLOYEE_CALLS: 'sidebar.dashboard_employee_calls',
  SIDEBAR_DASHBOARD_CLIENTS: 'sidebar.dashboard_clients',
  SIDEBAR_DASHBOARD_MAP: 'sidebar.dashboard_map',
  SIDEBAR_ABSENCES: 'sidebar.absences',
  SIDEBAR_ALERTS: 'sidebar.alerts',
  SIDEBAR_HOUR_ALERTS: 'sidebar.hour_alerts',
  SIDEBAR_FORMATIONS: 'sidebar.formations',
  EMPLOYEE_CCQ_UNION: 'employee.ccq_union',
  EMPLOYEE_RAMQ: 'employee.ramq',
  EMPLOYEE_QUALIFICATIONS_CCQ: 'employee.qualifications_ccq',
  EMPLOYEE_QUALIFICATIONS_TRADES: 'employee.qualifications_trades',
  I18N_LANGUAGE_SWITCH: 'i18n.language_switch',
} as const satisfies Record<string, FeatureKey>
